export default "__VITE_ASSET__CRixaw_G__"